// Folliq Red Light Therapy Cap · v7 (Megelin structure). Plain module, no dependencies.
let CartAddEvent = null;
try { ({ CartAddEvent } = await import('@theme/events')); } catch (e) { /* cart page fallback still works */ }

const root = document.querySelector('[data-fm]');
if (root) init(root);

function init(root) {
  const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = () => matchMedia('(max-width: 989px)').matches;

  /* ---------- gallery ---------- */
  const gal = root.querySelector('[data-fm-gal]');
  if (gal) {
    const track = gal.querySelector('[data-fm-track]');
    const slides = [...gal.querySelectorAll('[data-fm-slide]')];
    const thumbs = [...gal.querySelectorAll('[data-fm-thumb]')];
    const dots = [...gal.querySelectorAll('.fm-gal__dot')];
    const strip = gal.querySelector('[data-fm-thumbs]');
    let cur = 0;
    const set = (i) => {
      cur = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      const t = thumbs[i];
      if (t && strip) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    };
    const go = (i) => {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      set(i);
    };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur && slides[i]) set(i); }); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.fmThumb)));
    gal.querySelector('[data-fm-tprev]')?.addEventListener('click', () => go(cur - 1));
    gal.querySelector('[data-fm-tnext]')?.addEventListener('click', () => go(cur + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    const warm = () => slides.forEach((s) => { const im = s.querySelector('img'); if (im) im.loading = 'eager'; });
    if (document.readyState === 'complete') warm(); else addEventListener('load', warm, { once: true });
  }

  /* ---------- sets + price ---------- */
  const form = root.querySelector('[data-fm-form]');
  const inputs = form ? [...form.querySelectorAll('input[name="id"]')] : [];
  const priceBox = form ? form.querySelector('[data-fm-price]') : null;
  const atc = root.querySelector('[data-fm-atc]');
  const status = root.querySelector('[data-fm-status]');
  const buyNow = root.querySelector('[data-fm-buynow]');
  const stickyPrice = root.querySelector('[data-fm-sticky-price]');
  const addBtns = [atc, ...root.querySelectorAll('[data-fm-add]')].filter(Boolean);
  const selected = () => inputs.find((i) => i.type === 'hidden' || i.checked) || inputs[0];
  const sync = () => {
    const v = selected(); if (!v) return;
    const ok = v.dataset.available === 'true';
    root.querySelectorAll('.fm-set, .f8-set').forEach((l) => l.classList.toggle('is-on', l.contains(v)));
    if (v.type === 'radio') {
      const n = v.dataset.now || '';
      root.querySelectorAll('[data-fm-atc-price]').forEach((el) => { el.textContent = n ? '· ' + n : ''; el.hidden = !n; });
      root.querySelectorAll('[data-fm-per]').forEach((el) => { if (v.dataset.per) el.textContent = v.dataset.per; });
    } else {
      const hp = root.querySelector('.f8-card [data-fm-atc-price]');
      if (hp) root.querySelectorAll('[data-fm-atc-price]').forEach((el) => { el.textContent = hp.textContent; el.hidden = hp.hidden; });
    }
    if (priceBox && v.type === 'radio') {
      const n = v.dataset.now || '', w = v.dataset.was || '', o = v.dataset.off || '';
      priceBox.hidden = !n;
      priceBox.querySelector('[data-fm-now]').textContent = n;
      const was = priceBox.querySelector('[data-fm-was]'); was.textContent = w; was.hidden = !w;
      const off = priceBox.querySelector('[data-fm-off]'); off.textContent = o; off.hidden = !o;
      const day = root.querySelector('[data-fm-day]'); if (day) { day.textContent = v.dataset.day || ''; day.hidden = !v.dataset.day; }
    }
    if (stickyPrice) stickyPrice.textContent = priceBox && !priceBox.hidden ? priceBox.querySelector('[data-fm-now]').textContent : '';
    addBtns.forEach((b) => { b.disabled = !ok; const l = b.querySelector('[data-fm-label]'); if (l && atc && (b === atc || !ok)) l.textContent = ok ? atc.dataset.label : atc.dataset.soldout; });
    if (buyNow) buyNow.disabled = !ok;
    if (v.type === 'radio') { try { const u = new URL(location.href); u.searchParams.set('variant', v.value); history.replaceState(history.state, '', u); } catch (e) {} }
  };
  inputs.forEach((i) => i.addEventListener('change', sync));
  sync();

  const qIn = root.querySelector('[data-fm-qty-input]');
  const qty = () => Math.max(1, Math.min(10, parseInt(qIn ? qIn.value : '1', 10) || 1));
  root.querySelectorAll('[data-fm-step]').forEach((b) => b.addEventListener('click', () => { if (qIn) qIn.value = Math.max(1, Math.min(10, qty() + +b.dataset.fmStep)); }));

  const say = (m, err) => { if (!status) return; status.textContent = m; status.classList.toggle('is-err', !!err); };
  const label = (b, t) => { const l = b.querySelector('[data-fm-label]'); if (l) l.textContent = t; };
  let busy = false;
  async function add(btn, checkout) {
    const forced = btn && btn.dataset.fmAddVariant;
    const v = forced ? { value: forced, dataset: { available: 'true' } } : selected();
    if (busy || !v || v.dataset.available !== 'true') return;
    busy = true;
    const lblEl = btn.querySelector('[data-fm-label]');
    const base = lblEl ? lblEl.textContent : (atc ? atc.dataset.label : '');
    btn.classList.add('is-busy'); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    if (atc) label(btn, atc.dataset.adding);
    say('');
    try {
      const r = await fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +v.value, quantity: qty() }] }) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(r.status === 422 && data.description ? data.description : 'add');
      if (checkout) { location.href = R + 'checkout'; return; }
      const cart = await (await fetch(R + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      if (CartAddEvent) document.dispatchEvent(new CartAddEvent(cart, 'fm-cap', { itemCount: cart.item_count, source: 'fm-cap' }));
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      if (atc) { label(btn, atc.dataset.added); say(atc.dataset.added); }
      setTimeout(() => { btn.classList.remove('is-done'); label(btn, base); }, 2400);
    } catch (e) {
      btn.classList.remove('is-busy'); label(btn, base);
      say(e && e.message && e.message !== 'add' ? e.message : (root.dataset.err || 'Something went wrong.'), true);
    } finally { btn.disabled = false; btn.removeAttribute('aria-busy'); busy = false; }
  }
  form?.addEventListener('submit', (e) => { e.preventDefault(); add(atc); });
  root.querySelectorAll('[data-fm-add], [data-fm-add-variant]').forEach((b) => b.addEventListener('click', () => add(b)));

  /* ---------- v8: "Is it a fit?" checker (no data leaves the page) ---------- */
  const chk = root.querySelector('[data-f8-checker]');
  if (chk) {
    const ans = {};
    const resA = chk.querySelector('[data-f8-res="a"]');
    const resB = chk.querySelector('[data-f8-res="b"]');
    chk.querySelectorAll('[data-q]').forEach((b) => b.addEventListener('click', () => {
      ans[b.dataset.q] = b.dataset.v;
      chk.querySelectorAll(`[data-q="${b.dataset.q}"]`).forEach((o) => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
      const done = ['1', '2', '3'].every((k) => ans[k]);
      const anyB = Object.values(ans).includes('b');
      resB.hidden = !anyB;
      resA.hidden = anyB || !done;
    }));
  }
  buyNow?.addEventListener('click', () => { if (buyNow.textContent) add(buyNow, true); });

  /* ---------- sticky ---------- */
  const sticky = root.querySelector('[data-fm-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    let past = false, end = false;
    const apply = () => { const on = past && !end; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); sticky.querySelectorAll('button').forEach((b) => { b.tabIndex = on ? 0 : -1; }); };
    // Desktop: show once the main button has scrolled past. Mobile (2026-10-07): also while the main button is still
    // below the first screen, so Add to cart is always one tap away (persistent mobile ATC).
    const mq = matchMedia('(max-width: 989px)');
    new IntersectionObserver(([en]) => { past = !en.isIntersecting && (en.boundingClientRect.top < 0 || mq.matches); apply(); }).observe(atc);
    const foot = root.querySelector('.fm-foot');
    if (foot) new IntersectionObserver(([en]) => { end = en.isIntersecting; apply(); }).observe(foot);
  }

  /* ---------- generic tabs: [data-fm-tabs] with [data-fm-tab] buttons and [data-fm-panel] ---------- */
  root.querySelectorAll('[data-fm-tabs]').forEach((box) => {
    const btns = [...box.querySelectorAll('[data-fm-tab]')];
    const panels = [...box.querySelectorAll('[data-fm-panel]')];
    const pick = (i) => {
      btns.forEach((b) => { const on = +b.dataset.fmTab === i; b.classList.toggle('is-on', on); if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach((p) => { p.hidden = +p.dataset.fmPanel !== i; });
    };
    btns.forEach((b) => b.addEventListener('click', () => pick(+b.dataset.fmTab)));
  });

  /* ---------- technology number cards ---------- */
  const car = root.querySelector('[data-fm-car]');
  if (car) {
    const tr = car.querySelector('[data-fm-car-track]');
    const items = [...car.querySelectorAll('[data-fm-car-item]')];
    const marks = [...car.querySelectorAll('.fm-ncar__prog span')];
    const now = car.querySelector('[data-fm-car-now]');
    let i = 0;
    const show = (n) => {
      i = (n + items.length) % items.length;
      items.forEach((it, k) => it.classList.toggle('is-on', k === i));
      marks.forEach((m, k) => m.classList.toggle('is-on', k === i));
      if (now) now.textContent = String(i + 1).padStart(2, '0');
      const it = items[i];
      tr.scrollTo({ left: it.offsetLeft - tr.offsetLeft - (mobile() ? (tr.clientWidth - 245) / 2 : 4), behavior: reduce ? 'auto' : 'smooth' });
    };
    car.querySelector('[data-fm-car-prev]')?.addEventListener('click', () => show(i - 1));
    car.querySelector('[data-fm-car-next]')?.addEventListener('click', () => show(i + 1));
    items.forEach((it, k) => it.addEventListener('click', () => show(k)));
  }

  /* ---------- comfort slider + numbered pills ---------- */
  const cf = root.querySelector('[data-fm-comfort]');
  if (cf) {
    const frames = [...cf.querySelectorAll('[data-fm-cframe]')];
    const pills = [...cf.querySelectorAll('[data-fm-citem]')];
    let c = 0;
    const show = (n) => {
      c = (n + frames.length) % frames.length;
      frames.forEach((f, k) => f.classList.toggle('is-on', k === c));
      pills.forEach((p, k) => { p.classList.toggle('is-on', k === c); p.querySelector('button').setAttribute('aria-expanded', k === c ? 'true' : 'false'); });
    };
    cf.querySelector('[data-fm-cprev]')?.addEventListener('click', () => show(c - 1));
    cf.querySelector('[data-fm-cnext]')?.addEventListener('click', () => show(c + 1));
    pills.forEach((p, k) => p.querySelector('button').addEventListener('click', () => show(k)));
  }

  /* ---------- anytime, anywhere ---------- */
  const cv = root.querySelector('[data-fm-curve]');
  if (cv) {
    const tr = cv.querySelector('[data-fm-curve-track]');
    let u = 0;
    const move = (d) => {
      const items = [...tr.children];
      if (mobile()) {
        u = (u + d + items.length) % items.length;
        tr.style.transform = `translateX(${-u * (items[0].getBoundingClientRect().width + 12)}px)`;
      } else if (d > 0) tr.appendChild(items[0]); else tr.insertBefore(items[items.length - 1], items[0]);
    };
    cv.querySelector('[data-fm-uprev]')?.addEventListener('click', () => move(-1));
    cv.querySelector('[data-fm-unext]')?.addEventListener('click', () => move(1));
    let x0 = null;
    tr.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    tr.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1); x0 = null; });
  }

  /* ---------- reviews: show 5, then more ---------- */
  const list = root.querySelector('[data-fm-revlist]');
  const more = root.querySelector('[data-fm-revmore]');
  if (list && more) {
    let shown = 5;
    const paint = () => { [...list.children].forEach((r, k) => r.classList.toggle('is-hidden', k >= shown)); more.hidden = shown >= list.children.length; };
    more.addEventListener('click', () => { shown += 5; paint(); });
    paint();
  }

  /* ---------- autoplay videos: play only when visible, respect reduced motion ---------- */
  root.querySelectorAll('[data-fm-autoplay]').forEach((v) => {
    v.muted = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.2 }).observe(v);
    } else v.play().catch(() => {});
  });

  /* ---------- footer columns collapse on mobile ---------- */
  if (mobile()) root.querySelectorAll('.fm-foot__col').forEach((d) => d.removeAttribute('open'));
}
